import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-links">
        <a href="/impressum">Impressum</a>
        <a href="/datenschutz">Datenschutzerklärung</a>
        <a href="/agb">AGB</a>
      </div>
      <p className="footer-copy">&copy; {new Date().getFullYear()} Chiara Körner</p>
    </footer>
  );
};

export default Footer;
